/**
 * @hidden
 * Class providing meta data about a fragment of content with helper functions.
 */
export class FragmentMeta {
    /**
     * Creates a new FragmentMeta instance.
     * @param data JSON representation of the FragmentMeta model
     */
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    /**
     * Export to JSON
     */
    toJSON() {
        return {
            schema: this.schema
        };
    }
    /**
     * @hidden
     * Returns true if the provided node contains meta data to self-describe the JSON schema it was created against.
     * @param node JSON node to test
     */
    static isFragment(node) {
        return node != null && node._meta != null && node._meta.schema != null;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnJhZ21lbnRNZXRhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb250ZW50L21vZGVsL0ZyYWdtZW50TWV0YS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7QUFDSCxNQUFNLE9BQU8sWUFBWTtJQU12Qjs7O09BR0c7SUFDSCxZQUFZLElBQVU7UUFDcEIsSUFBSSxJQUFJLEVBQUU7WUFDUixNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztTQUMzQjtJQUNILENBQUM7SUFFRDs7T0FFRztJQUNILE1BQU07UUFDSixPQUFPO1lBQ0wsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1NBQ3BCLENBQUM7SUFDSixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxVQUFVLENBQUMsSUFBUztRQUNoQyxPQUFPLElBQUksSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLElBQUksSUFBSSxDQUFDO0lBQ3pFLENBQUM7Q0FDRiJ9